<template>
  <section id="behandlung">
    <h2 class="text-uppercase text-center">
      Behandlung
    </h2>
    <p>
      Nach einem ausführlichen Anamnesegespräch zu Beginn der Behandlung folgt die detaillierte Untersuchung von Kopf bis Fuss. 
      Untersuchung und Behandlung gehen fliessend ineinander über, wobei sich die Behandlung immer nach dem aktuellen Befund richtet und jeweils individuell ist.
    </p>
    <p>
      Bitte planen Sie pro Termin ca. 45 min Zeit ein, für den Ersttermin gern etwas mehr. Die Kosten orientieren sich an der Gebührenordnung für Heilpraktiker*innen (GebüH) und liegen bei ca. 90 Euro pro Termin.
    </p>
    <p>
      Die Osteopathie ist eine Privatleistung, wird jedoch von immer mehr gesetzliche Krankenkassen bezuschusst. In diesem Fall können Sie die Rechnung bei Ihrer Kasse einreichen und bekommen nachträglich einen Anteil der Behandlungskosten erstattet.
    </p> 
    <p>
      <a
        href="https://www.osteokompass.de/patienteninfo-krankenkassen"
        target="_blank"
      ><strong>Hier</strong> finden sie eine Auflistung von Kassen welche Osteopathie unterstützen</a>.
    </p>
    <p>
      Als Voraussetzungen für eine Zuzahlung gelten oft die Mitgliedschaft in einem Berufsverband der Osteopath*innen, sowie eine mehrjährige Ausbildung mit über 1350 Stunden. Diese werden von mir erfüllt.
    </p>
    <p>
      Falls Sie einen vereinbarten Termin nicht wahrnehmen können geben Sie bitte <strong>24 Stunden vorher</strong> Bescheid.<br> Andernfalls müssen die Kosten für den Termin in Rechnung gestellt werden.
    </p>
  </section>
</template>

<script>
export default {
    name: "ContentBehandlung",
    mounted: function() {
      if(this.$route.path && this.$route.path == '/behandlung') {
        const element = document.getElementById(this.$route.path.substring(1));
        if(element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }
}
</script>
